import React from 'react'
import { connect } from 'react-redux'
import FinanceSettingCollege from './FinanceSettingCollege';
import DetailsHolder from '../Colleges/DetailsHolder';

const FinanceCollegeTab = ({ college, user }) => {
  return (
    <DetailsHolder college={college} activePath='/FinanceSettingCollege'>
      <FinanceSettingCollege
        user={user}
        institution={college.institution}
        campuses={college.campuses}
        classes={college.classes}
        isViewAsAdmin
      />
    </DetailsHolder>
  )
}

function mapStateToProps(state) {
  return {
    college: state.admin.college_details,
    user: state.user.user
  }
}

export default connect(mapStateToProps)(FinanceCollegeTab)
